import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingState = () => {
  return (
    <div 
      className="min-h-screen bg-[#09090B] flex items-center justify-center"
      data-testid="loading-state"
    >
      <div className="text-center">
        <div className="relative">
          <div className="w-16 h-16 border-4 border-[#27272A] rounded-full" />
          <div className="absolute top-0 left-0 w-16 h-16 border-4 border-[#3B82F6] border-t-transparent rounded-full animate-spin" />
        </div>
        <h2 className="mt-6 text-xl font-bold text-white">Loading Market Intelligence</h2>
        <p className="mt-2 text-[#A1A1AA]">Fetching latest Canadian vehicle market data...</p>
      </div>
    </div>
  );
};

export default LoadingState;
